import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import snakeCase from 'lodash/snakeCase';

import { collectSearchParams } from 'utils/collectSearchParams';
import { STORAGE_KEYS } from 'utils/constants/constants';

export default function() {
  const { push, location } = useHistory();

  return useCallback(({ modalName = '', modalProps = {} }) => {
    let search: {};

    if (!isEmpty(modalName)) {
      search = {
        ...collectSearchParams(new URLSearchParams(location.search)),
        modal_name: snakeCase(modalName),
      };

      sessionStorage.setItem(STORAGE_KEYS.modalProps, JSON.stringify(modalProps));
    } else {
      search = omit(collectSearchParams(new URLSearchParams(location.search)), 'modal_name');

      sessionStorage.removeItem(STORAGE_KEYS.modalProps);
    }

    push({ search: new URLSearchParams(search).toString() });
  }, [location.search]);
}
